import { useState } from 'react'
import { BMToken, DAPIToken } from './portlet/Token';
import ResourceEnvironment from './portlet/ResourceEnvironment';
import { GlobalProvider } from './context/GlobalProvider';
import TrackOrderManager from './TrackOrderManager';

import "./App.scss";

interface Props {
    rtl: boolean;
}

function App() {
    const [isResource, setIsResource] = useState(true)
    const [isBm, setIsBm] = useState(true)
    const [isDapi, setIsDapi] = useState(true)

    const getResourceLoading = (loading: any) => {
        setIsResource(loading)
    }

    const getBmLoading = (loading: any) => {
        setIsBm(loading)
    }

    const getDapiLoading = (loading: any) => {
        setIsDapi(loading)
    }

    return (
        <GlobalProvider>
            <ResourceEnvironment resourceLoading={getResourceLoading} />
            <BMToken bmLoading={getBmLoading} />
            <DAPIToken dapiLoading={getDapiLoading} />
            {(!isResource && !isBm && !isDapi) && <TrackOrderManager />}
        </GlobalProvider>
    );
}

export default App;